<template>
  <div
    class="fapi-form-alert f-bg-red-100 f-border f-border-red-400 f-text-red-700 f-px-4 f-py-3 f-rounded f-relative"
    role="alert"
  >
    {{ message }}
  </div>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  name: "Alert",

  props: {
    message: {
      type: String,
      required: true,
    },
    scrollIntoView: {
      type: Boolean,
      default: false,
    },
  },

  mounted(): void {
    if (!this.scrollIntoView) {
      return;
    }

    this.$el.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  },
});
</script>

<style lang="scss"></style>
